/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocation_Accept_Button1Inputs */

const en_coinvestments_allocation_accept_button1 = /** @type {(inputs: Coinvestments_Allocation_Accept_Button1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept Allocation`)
};

/**
* | output |
* | --- |
* | "Accept Allocation" |
*
* @param {Coinvestments_Allocation_Accept_Button1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocation_accept_button1 = /** @type {((inputs?: Coinvestments_Allocation_Accept_Button1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocation_Accept_Button1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocation_accept_button1(inputs)
});
export { coinvestments_allocation_accept_button1 as "coInvestments_allocation_accept_button" }